export const REPORTS_VIEW = "/reports"
export const FARM_REPORTS_VIEW = `${REPORTS_VIEW}/farm`
export const ANIMALS_REPORTS_VIEW = `${REPORTS_VIEW}/animals`
